var md5 = require('md5')

function PasswordCrypter (saltBefore, saltAfter) {
  this.saltBefore = saltBefore
  this.saltAfter = saltAfter
  var self = this
  this.cryptPassword = function (str) {
    return md5(self.saltBefore + str + self.saltAfter)
  }
}

export default PasswordCrypter
